import { Coins } from "lucide-react";
import { formatCredits } from "@/hooks/useResourceCredits";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface CreditBadgeProps {
  amount: number;
  loading?: boolean;
  label?: string;
  className?: string;
  size?: "sm" | "md";
}

export function CreditBadge({ amount, loading, label, className, size = "sm" }: CreditBadgeProps) {
  if (loading || amount === 0) return null;

  const formatted = formatCredits(amount);
  const text = label ? `${formatted} ${label}` : `${formatted} cr`;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={cn(
            "inline-flex items-center gap-1 rounded-full font-mono",
            size === "sm"
              ? "text-[10px] px-1.5 py-0 h-4 bg-muted/60 text-muted-foreground"
              : "text-xs px-2 py-0.5 bg-muted text-muted-foreground",
            className
          )}
        >
          <Coins className={cn(size === "sm" ? "w-2.5 h-2.5" : "w-3 h-3", "text-amber-500")} />
          {text}
        </span>
      </TooltipTrigger>
      <TooltipContent side="bottom" className="text-xs">
        Credits used by you on this {label || "resource"}
      </TooltipContent>
    </Tooltip>
  );
}
